export enum ContentTypeOption {
  TEXT = 'text',
  MEDIA = 'media'
}